export default {
    state: {
        loader: false
    },

    getters: {
        loader: state => state.loader
    }
}